import HeaderCartsMigrationInfo from "./HeaderCartsMigrationInfo";

export default HeaderCartsMigrationInfo;
